import React from 'react';
import NumberFormat from 'react-number-format';

interface Props {
  value: string;
}

const FormatPhone = (props: Props): JSX.Element => {
  return (
    <NumberFormat
      displayType={'text'}
      value={props.value}
      format="(###) ###-####"
      mask="_"
    />
  );
};

export default FormatPhone;
